import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    standalone: true,
    name: 'GetFileExt',
})
export class FileExtensionPipe implements PipeTransform {
    constructor() { }

    transform(str: string) {
        console.log(str?.split('.').pop());
        
        return str?.split('.').pop();
    }
}
